<template>
  <div class="popup-page">
    <div v-if="popupItem && popupItem.id && !popupItem.isShow && popupItem.popupAttributes.icon_image" class="popup-list">
      <div class="popup-item pointer" @click="showPopup = true">
        <oss-img :width="60" :height="60" :src="popupItem.popupAttributes.icon_image" />
      </div>
    </div>
    <div v-if="showPopup" class="ad-popup">
      <div class="content">
        <div class="img">
          <oss-img :width="672" :height="500" :src="popupItem.mainImage" />
        </div>
        <div class="box" :class="{ pointer: popupItem.popupAttributes.popup_link }" @click="jump(popupItem)">
          <div v-if="popupItem.countdownEndTime" class="countDown">
            <Time :deadline="popupItem.countdownEndTime" />
          </div>
        </div>
        <div class="close f-c-c pointer" @click="showPopup = false">
          <i class="iconfont icon-a-close-line1"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import API from '@/api'
import Time from '@/views/index/components/Time.vue'
import _ from 'lodash'
import OssImg from './OssImg.vue'
export default {
  components: {
    Time,
    OssImg
  },
  data() {
    return {
      popupList: [],
      showPopup: false,
      popupItem: {},
      shopifyList: []
    }
  },
  computed: {
    userId() {
      return this.$store.state.common.userId
    }
  },
  watch: {
    '$route.path'(e) {
      this.showPopupHandle(this.popupList)
    }
  },
  created() {
    if (this.userId) {
      this.getStoreSelect()
    } else {
      this.init()
    }
  },
  mounted() {
  },
  methods: {
    init() {
      this.popupList = JSON.parse(sessionStorage.getItem('adPopupConfig'))
      if (!this.popupList) {
        this.getProcessingPopup()
      } else {
        this.showPopupHandle(this.popupList)
      }
    },
    // 获取弹窗列表
    getProcessingPopup() {
      API.getProcessingPopup({ type: 0 }).then(res => {
        if (res.code !== 10000) return
        if (res.data.list && res.data.list.length) {
          this.popupList = res.data.list.map(item => ({ ...item, isShow: true }))
          sessionStorage.setItem('adPopupConfig', JSON.stringify(this.popupList))
          this.showPopupHandle(this.popupList)
        }
      })
    },
    // 是否显示弹窗
    showPopupHandle(arr) {
      let popup = this.popupItemHandle(arr)
      this.popupItem = popup
      if (!popup || !popup.isShow) return
      setTimeout(() => {
        this.showPopup = true
        this.$record({
          eventType: 'exposure',
          eventId: `adPopup_exposure`,
          value: JSON.stringify({
            id: popup.id
          })
        })
        this.updatePopup(popup)
      }, (+popup.popupRules.delay_time || 0) * 1000)
    },
    // 弹窗显示规则
    popupItemHandle(popup) {
      let arr = _.cloneDeep(popup)
      // 接受对象: 0所有，1未登录，2已登录
      arr = _.filter(arr, item => {
        if (+item.popupRules.accept_type === 0) return true
        else if (this.userId && item.popupRules.accept_type === 2) return true
        else if (!this.userId && item.popupRules.accept_type === 1) return true
        else if (this.userId && item.popupRules.accept_type === 3) {
          return (this.shopifyList && this.shopifyList.length)
        } else return false
      })

      // 显示页面: 0首页，2全部页面
      arr = _.filter(arr, item => {
        if (+item.popupRules.display_page_type === 2) return true
        else if (item.popupRules.display_page_type === 0 && ['/mall', '/', '', '/mall/'].includes(this.$route.path)) return true
        else return false
      })

      if (arr.length > 1) return arr[arr.length - 1]
      else if (arr.length === 1) return arr[0]
      else return null
    },
    // 更新弹窗
    updatePopup(popup) {
      this.popupList.forEach(item => {
        if (item.id === popup.id) {
          item.isShow = false
          this.$set(this.popupItem, 'isShow', false)
        }
      })
      sessionStorage.setItem('adPopupConfig', JSON.stringify(this.popupList))
    },
    jump(popup) {
      let path = popup.popupAttributes.popup_link
      if (!path) return
      this.$record({
        eventType: 'click',
        eventId: `adPopupJump_click`,
        value: JSON.stringify({
          id: popup.id
        })
      })
      const website = this.$store.state.website
      let url = website.filter(t => path.includes(t))
      if (url.length) {
        url = path.split(url[0])[1]
        this.$router.push(url)
      } else window.open(path)
      this.showPopup = false
    },

    // 获取用户店铺  (Shopify店铺)
    getStoreSelect() {
      API.getStoreSelect({
        platformCode: 'SP',
        userId: this.$store.state.common.userId
      }).then(result => {
        this.shopifyList = result.data || []
      }).finally(() => {
        this.init()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.popup-list {
  position: fixed;
  left: calc((100vw - 1660px) / 2) ;
  bottom: 110px;
  z-index: 10;
  .popup-item {
    width: 110px;
    height: 110px;
    margin-top: 20px;
    >img{
      width: 100%;
    }
  }
}
@media screen and (max-width:1690px) {
  .popup-list{
    left: 20px;
  }
}

.ad-popup {
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.38);
  z-index: 3000;
  .content {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    width: 737px;
    height: 500px;
    display: flex;
    justify-content: space-between;
    .img{
      position: absolute;
      width: 672px;
      height: 500px;
      top: 0;
      left: 0;
      >img {
        width: 100%;
        height: 100%;
      }
    }
    .box {
      width: 672px;
      height: 100%;
      position: relative;

      .countDown {
        display: flex;
        justify-content: center;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 176px;
        margin: auto;
        /deep/ .time-comp{
          .block{
            background-color: #fff;
            color:#000;
            width: 34px;
            height: 50px;
            line-height: 50px;
            font-family: 'Poppins';
            margin-right: 4px;
          }
          .colon{
            width: 9px;
            margin-right: 2px;
            .circular{
              width: 5.4px;
              height: 5.3px;
              border-radius: 50%;
              background-color: #fff;
            }
          }
        }
      }
    }
    .close {
      width: 56px;
      height: 56px;
      background-color: #fff;
      i {
        font-size: 36px;
      }
    }
  }
}
</style>
